import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, Button, Text } from '@chakra-ui/react';

import FormInput from '../../components/form/FormInput';
import LogoBox from '../../components/Header/LogoBox';
import loginBackground from '../../loginBackground.png';
import { createErrorToast, createSuccessToast } from '../../redux/modules/app';
import { useForgotPassword } from '../../services/user-service';
import boxStyles from '../../styles/boxStyles';
import colors from '../../styles/theme/foundation/colors';

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const useFormMethods = useForm();
  const { handleSubmit } = useFormMethods;

  const { mutateAsync } = useForgotPassword();

  const onSubmit = async data => {
    const resp = await mutateAsync({ email: data.email_address });

    if (resp?.error) {
      dispatch(createErrorToast({ title: resp.error }));

      return;
    }

    if (resp?.success) {
      dispatch(createSuccessToast({ title: resp.success }));
    }
  };

  return (
    <Box
      backgroundImage={loginBackground}
      backgroundPosition="center"
      backgroundSize="cover"
      h="100vh"
      position="relative"
      w="100vw"
    >
      <Box
        h="40px"
        left={6}
        position="absolute"
        top={6}
      >
        <LogoBox to="/" />
      </Box>
      <Box
        alignItems="center"
        display="flex"
        h="100%"
        justifyContent="center"
        p={6}
      >
        <Box
          bgColor={colors.white}
          borderRadius="sm"
          boxShadow={boxStyles.boxShadow}
          mx="auto"
          my="auto"
          p={8}
          w="450px"
        >
          <Text
            mb={4}
            textAlign="center"
            textStyle="displayXs"
          >
            Forgot your password?
          </Text>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box mb={2}>
              <FormInput
                inputName="email_address"
                labelName="Email Address"
                placeholder="Email Address"
                useFormMethods={useFormMethods}
                validationRules={{ required: 'Please provide an email address.' }}
              />
            </Box>

            <Button mb={4} type="submit" w="100%">Send Link</Button>
            <Button
              mb={4}
              variant="textPrimary"
              w="100%"
              onClick={() => history.push('login')}
            >
              Back to Log In
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPasswordPage;
